import { useEffect } from 'react';

import { modalTypes } from '@/enums';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getIsVipConfirmationEligible } from '@/redux/modules/account/user/user.selectors';
import { openVipConfirmationModal } from '@/redux/modules/modal';
import { getOpenModal } from '@/redux/modules/modal.selectors';
import { useVipConfirmationExperiment } from '@/utils/amplitude/experiments/hooks/useVipConfirmation.experiment';

import { VipConfirmationModal } from './VipConfirmationModal';

// Temporary storage for QA while waiting for the backend to be updated
const VIP_CONFIRMATION_STORAGE_KEY = 'vipConfirmation';

const hasSeenVipConfirmation = () =>
    typeof window !== 'undefined' && localStorage.getItem(VIP_CONFIRMATION_STORAGE_KEY) === 'true';

const VipConfirmationModalTrigger = () => {
    const dispatch = useAppDispatch();
    const isBackendEligible = useAppSelector(getIsVipConfirmationEligible);
    const isExperimentTreatment = useVipConfirmationExperiment();
    const isVipConfirmationEligible = isBackendEligible || isExperimentTreatment;
    const openModal = useAppSelector(getOpenModal);
    const isVipOpen = openModal === modalTypes.VIP_CONFIRMATION;
    const isModalOpen = openModal !== modalTypes.NONE;
    const shouldOpen = isVipConfirmationEligible && !isModalOpen && !hasSeenVipConfirmation();

    useEffect(() => {
        if (shouldOpen) {
            localStorage.setItem(VIP_CONFIRMATION_STORAGE_KEY, 'true');
            dispatch(openVipConfirmationModal());
        }
    }, [dispatch, shouldOpen]);

    if (!isVipOpen) {
        return null;
    }

    return <VipConfirmationModal />;
};

export default VipConfirmationModalTrigger;
